import React, {Component} from "react"
import { Navigate } from "react-router-dom";
import { dontMakeSilentCallOnOpen, setLegitCall, setAvailableNearby } from "../../Redux/TrackerActions";
import {store} from "../../App";
import { connect } from 'react-redux';
import { setToast, setDialog, clearDialog, setLoader, clearLoader } from "../../Redux/OverlayActions";
import { askForPermissionToReceiveNotifications, isMessagingAvailable } from '../../push-notification';
import { withTranslation } from "../../hooks/withTranslation";
import { getDistanceFromLatLonInKm } from "../../utils/geo";

class SilentCallButton extends Component {
    constructor() {
        super();
        this.state = {
            redirectToSilentAddress: false,

            showLocationFailedDialog: false,
            showLocationDeniedDialog: false,

            silentOproepGeplaatst: false,
        };

        this.handleClick = this.handleClick.bind(this);

        this.checkPermissionLocation = this.checkPermissionLocation.bind(this);

        this.preRequestPermissionLocation = this.preRequestPermissionLocation.bind(this);
        this.handlePreRequestPermissionLocationResponse = this.handlePreRequestPermissionLocationResponse.bind(this);

        this.requestLocation = this.requestLocation.bind(this);
        this.handleLocationRecieved = this.handleLocationRecieved.bind(this);
        this.handleLocationError = this.handleLocationError.bind(this);
        this.handleLocationDenied = this.handleLocationDenied.bind(this);
        this.handleLocationFailed = this.handleLocationFailed.bind(this);

        this.checkGeopositionAgainstStoredPosition = this.checkGeopositionAgainstStoredPosition.bind(this);

        this.makeLocationTranslation = this.makeLocationTranslation.bind(this);
        this.handleLocationTranslationFailed = this.handleLocationTranslationFailed.bind(this);
        this.setAdresStorage = this.setAdresStorage.bind(this);
        this.isStoredAddressValid = this.isStoredAddressValid.bind(this);

        this.handleSilentCall = this.handleSilentCall.bind(this);
        this.handleSilentCallResponse = this.handleSilentCallResponse.bind(this);

        this.watchdogTimeout = this.watchdogTimeout.bind(this);
        this.requestNotifications = this.requestNotifications.bind(this);
        this.postForm = this.postForm.bind(this);
        this.handleSubmitFailure = this.handleSubmitFailure.bind(this);
        this.handleSubmitSucces = this.handleSubmitSucces.bind(this);
        this.deleteForm = this.deleteForm.bind(this);
        this.handleDeleteFailure = this.handleDeleteFailure.bind(this);
        this.handleDeleteSucces = this.handleDeleteSucces.bind(this);
    }

    componentDidMount() {
        const silentCallActive =  (window.localStorage.getItem('token') || false) && (window.localStorage.getItem('silentCallActive') || false);

        if (silentCallActive > 0) {
            console.log(silentCallActive);
            this.setState({
                silentOproepGeplaatst: true,
            });
        }

        if (this.props.makeSilentCallOnOpen) {
            this.handleClick(true);
        }
        store.dispatch(dontMakeSilentCallOnOpen());
    }

    handleClick(skipLocationPopup = false) {
        this.props.handleMapClick();

        if (this.state.silentOproepGeplaatst) {
            this.deleteForm();
        } else {
            this.checkPermissionLocation(skipLocationPopup);
        }
    }

    checkPermissionLocation(skipLocationPopup = false) {
        const that = this;
        navigator.permissions && navigator.permissions.query({name: 'geolocation'}).then(function(PermissionStatus) {
            if('granted' === PermissionStatus.state) {
                //Location permission granted
                that.requestLocation();
            } else if('denied' === PermissionStatus.state) {
                //Location permission denied
                that.checkGeopositionAgainstStoredPosition(null, null);
            } else {
                //Location permission unknown
                if (skipLocationPopup) {
                    that.checkGeopositionAgainstStoredPosition(null, null);
                } else {
                    that.preRequestPermissionLocation();
                }
            }
        });
        if (!navigator.permissions) {
            //This browser does not have the permissions API
            //Fallback to localstorage polyfill
            const geolocationState = window.localStorage.getItem('geolocation') || '';
            if('granted' === geolocationState) {
                //Location permission granted
                that.requestLocation();
            } else if('denied' === geolocationState) {
                //Location permission denied
                that.checkGeopositionAgainstStoredPosition(null, null);
            } else {
                //Location permission unknown
                if (skipLocationPopup) {
                    that.checkGeopositionAgainstStoredPosition(null, null);
                } else {
                    that.preRequestPermissionLocation();
                }
            }
        }
    }

    preRequestPermissionLocation() {
        const that = this;
        const { t } = this.props;
        store.dispatch(setDialog({
            title: t('dialogs.locationRequest.title', 'Wil je jouw locatie automatisch invullen?'),
            message: t('dialogs.locationRequest.message', 'Als je toegang tot jouw locatie toestaat, kunnen we je adres automatisch invullen.'),
            btn1Text: t('dialogs.locationRequest.acceptButton', 'Vul locatie automatisch in'),
            btn1Title: "accept",
            btn1Theme: "primary",
            btn2Text: t('dialogs.locationRequest.denyButton', 'Liever niet'),
            btn2Title: "deny",
            response: that.handlePreRequestPermissionLocationResponse,
        }));
    }

    handlePreRequestPermissionLocationResponse(response) {
        store.dispatch(clearDialog());
        if (response === "accept") {
            this.requestLocation();
        } else if (response === "deny" || response === "dismiss") {
            // this.handleLocationDenied();
            this.deleteForm(true);
            store.dispatch(clearDialog());
            this.checkGeopositionAgainstStoredPosition(null, null);
        }
    }

    requestLocation() {
        const { t } = this.props;
        store.dispatch(setLoader({
            title: t('loaders.pleaseWait', 'Even geduld...'),
            message: t('loaders.determiningLocation', 'We bepalen je locatie'),
        }));

        const options = {
            enableHighAccuracy: true,
            timeout: 30000,
            maximumAge: 300000 // 5 minutes - use cached location if available
        };

        navigator.geolocation.getCurrentPosition(
            (geoposition) => {
                console.log('[SilentCallButton] Location received:', geoposition.coords.latitude, geoposition.coords.longitude);
                this.handleLocationRecieved(geoposition);
            },
            (error) => {
                console.error('[SilentCallButton] Location error:', error);
                this.handleLocationError(error);
            },
            options
        );
    }

    handleLocationRecieved(geoposition) {
        store.dispatch(clearLoader());
        localStorage.setItem('geolocation', "granted");
        this.checkGeopositionAgainstStoredPosition(geoposition.coords.latitude, geoposition.coords.longitude);
    }

    handleLocationError(error) {
        store.dispatch(clearLoader());
        console.log('[SilentCallButton] Handling location error, code:', error.code);
        if (error.code === 1) {
            this.handleLocationDenied();
        } else {
            this.handleLocationFailed();
        }
    }

    handleLocationDenied() {
        localStorage.setItem('geolocation', "denied");
        const that = this;
        const { t } = this.props;
        store.dispatch(setDialog({
            title: t('dialogs.locationDenied.title', 'Je locatie kon niet worden bepaald'),
            message: t('dialogs.locationDenied.message', 'Je gaf geen toestemming om je adres automatisch te bepalen. Je zal je adres dus manueel moeten invullen.'),
            theme: "error",
            btn1Text: t('common.ok', 'Ok'),
            btn1Theme: "primary",
            response: () => {store.dispatch(clearDialog()); that.checkGeopositionAgainstStoredPosition(null, null)},
        }));
    }

    handleLocationFailed() {
        const that = this;
        const { t } = this.props;
        store.dispatch(setDialog({
            title: t('dialogs.locationFailed.title', 'Je locatie kon niet worden bepaald'),
            message: t('dialogs.locationFailed.message', 'Er ging iets mis tijdens het bepalen van je adres. Je zal je adres dus mogelijks manueel moeten invullen.'),
            btn1Text: t('common.ok', 'Ok'),
            btn1Theme: "primary",
            response: () => {store.dispatch(clearDialog()); that.checkGeopositionAgainstStoredPosition(null, null)},
        }));
    }

    checkGeopositionAgainstStoredPosition(lat, long) {
        if (!lat || !long) {
            //No GPS-latlong available
            const storedGpsLat = localStorage.getItem('gpslat') || null;
            const storedGpsLong = localStorage.getItem('gpslong') || null;
            if (!storedGpsLat || !storedGpsLong) {
                const storedLat = localStorage.getItem('latitude') || null;
                const storedLong = localStorage.getItem('longitude') || null;
                if (!storedLat || !storedLong) {
                    this.setState({
                        redirectToSilentAddress: true,
                    });
                } else {
                    if (this.isStoredAddressValid()) {
                        this.handleSilentCall();
                    } else {
                        store.dispatch(setToast({
                            message: this.props.t('toasts.addressIncomplete', 'Je adres is niet volledig juist. Gelieve je adres aan te vullen'),
                            theme: "error"
                        }));
                        this.setState({
                            redirectToSilentAddress: true,
                        });
                    }
                }
            } else {
                if (this.isStoredAddressValid()) {
                    this.handleSilentCall();
                } else {
                    store.dispatch(setToast({
                        message: this.props.t('toasts.addressIncomplete', 'Je adres is niet volledig juist. Gelieve je adres aan te vullen'),
                        theme: "error"
                    }));
                    this.setState({
                        redirectToSilentAddress: true,
                    });
                }
            }
        } else {
            //GPS returned latlong
            const storedGpsLat = localStorage.getItem('gpslat') || null;
            const storedGpsLong = localStorage.getItem('gpslong') || null;
            if (!storedGpsLat || !storedGpsLong) {
                this.makeLocationTranslation(lat, long);
            } else {
                const dist = getDistanceFromLatLonInKm(lat, long, storedGpsLat, storedGpsLong);
                if (dist < 0.5) {
                    if (this.isStoredAddressValid()) {
                        this.handleSilentCall();
                    } else {
                        store.dispatch(setToast({
                            message: this.props.t('toasts.addressIncomplete', 'Je adres is niet volledig juist. Gelieve je adres aan te vullen'),
                            theme: "error"
                        }));
                        this.setState({
                            redirectToSilentAddress: true,
                        });
                    }
                } else {
                    this.makeLocationTranslation(lat, long);
                }
            }
        }
    }

    isStoredAddressValid() {
        // Check that all required fields exist and are not empty
        // Note: localStorage.getItem returns null if key doesn't exist, so we need to check for both null and empty string
        const straat = localStorage.getItem('straat');
        const nr = localStorage.getItem('nr');
        const gemeente = localStorage.getItem('gemeente');
        const postcode = localStorage.getItem('postcode');
        const land = localStorage.getItem('land');
        const placeid = localStorage.getItem('placeid');

        return (straat && straat !== "" &&
                nr && nr !== "" &&
                gemeente && gemeente !== "" &&
                postcode && postcode !== "" &&
                land && land !== "" &&
                placeid && placeid !== "");
    }

    makeLocationTranslation(gpslat, gpslong) {
        const { t } = this.props;
        store.dispatch(setLoader({
            title: t('loaders.pleaseWait', 'Even geduld...'),
            message: t('loaders.fetchingLocation', 'We vragen je locatie op'),
        }));

        const formData = new FormData();
        formData.append('latitude', gpslat);
        formData.append('longitude', gpslong);

        fetch(process.env.REACT_APP_API_HREF+"legacycopy.php?action=get_adrestranslation",{
            method: 'POST',
            body: formData,
        }).then(function(response) {
            return response.json();
        }).then(data => {
            console.log(data);
            if (data.status === 200) {
                store.dispatch(clearLoader());

                const result = data.result;
                this.setAdresStorage(gpslat, gpslong, result.adres, result.latitude, result.longitude, result.Straat, result.Nr, result.Gemeente, result.Postcode, result.Land, result.place_id);
                this.handleSilentCall();
            } else {
                this.handleLocationTranslationFailed();
            }
        }).catch(error => {
            console.log(error);
            this.handleLocationTranslationFailed();
        });
    }

    handleLocationTranslationFailed() {
        store.dispatch(clearLoader());

        const that = this;
        const { t } = this.props;
        store.dispatch(setDialog({
            title: t('dialogs.locationFailed.title', 'Je locatie kon niet worden bepaald'),
            message: t('dialogs.locationFailed.message', 'Er ging iets mis tijdens het bepalen van je adres. Je zal je adres dus mogelijks manueel moeten invullen.'),
            btn1Text: t('common.ok', 'Ok'),
            btn1Theme: "primary",
            response: () => {store.dispatch(clearDialog()); that.checkGeopositionAgainstStoredPosition(null, null)},
        }));
    }

    setAdresStorage(gpslat, gpslong, adres, latitude, longitude, straat, nr, gemeente, postcode, land, place_id) {
        window.localStorage.setItem('gpslat', gpslat);
        window.localStorage.setItem('gpslong', gpslong);
        window.localStorage.setItem('adres', adres);
        window.localStorage.setItem('latitude', latitude);
        window.localStorage.setItem('longitude', longitude);
        window.localStorage.setItem('straat', straat);
        window.localStorage.setItem('nr', nr);
        window.localStorage.setItem('gemeente', gemeente);
        window.localStorage.setItem('postcode', postcode);
        window.localStorage.setItem('land', land);
        window.localStorage.setItem('placeid', place_id);
    }

    handleSilentCall() {
        store.dispatch(setAvailableNearby(true));
        const { t } = this.props;
        const address = (window.localStorage.getItem('adres') || "");
        const messageTemplate = t('dialogs.silentCall.messageTemplate', 'Wil je een notificatie krijgen als er een ijskar is in de buurt van <br /><b>"{address}"</b>?<br /><br />Je krijgt deze melding elke dag maximaal 1 keer tot je ze hier terug afzet.');
        store.dispatch(setDialog({
            title: t('dialogs.silentCall.title', 'Verwittig mij!'),
            message: messageTemplate.replace('{address}', address),
            btn1Text: t('dialogs.silentCall.confirmButton', 'Verwittig mij!'),
            btn1Theme: "primary",
            btn1Title: "roep",
            btn2Text: t('dialogs.silentCall.changeAddressButton', 'Adres wijzigen'),
            btn2Title: "adres",
            btn3Text: t('dialogs.silentCall.cancelButton', 'Annuleer'),
            btn3Title: "annuleer",
            response: (response) => { this.handleSilentCallResponse(response);},
        }));
    }

    handleSilentCallResponse(response) {
        if (response === "roep") {
            store.dispatch(clearDialog());
            store.dispatch(setLegitCall());
            this.requestNotifications();
        } else if (response === "adres") {
            store.dispatch(clearDialog());
            this.setState({
                redirectToSilentAddress: true,
            });
        } else if (response === "annuleer") {
            store.dispatch(clearDialog());
            this.deleteForm(true);
        }
    }

    async watchdogTimeout() {
        // FCM token retrieval requires service worker registration + token fetch
        // This can take 15-20+ seconds on slow connections or first load
        return new Promise(resolve => setTimeout(() => resolve({
            status: "FAIL",
            error: "Watchdog timeout"
        }), 30000));
    }

    async requestNotifications() {
        // Check if messaging is available
        if (!isMessagingAvailable()) {
            console.info('[SilentCallButton] Messaging not available, checking for existing token');
            // Fallback: use existing token or show error
            const existingToken = localStorage.getItem('fcm_token') || localStorage.getItem('token') || '';
            if (existingToken) {
                console.info('[SilentCallButton] Using existing token');
                this.postForm(existingToken);
            } else {
                console.warn('[SilentCallButton] No token available and messaging unavailable');
                store.dispatch(setToast({
                    message: this.props.t('toasts.notificationsUnavailable', 'Push notificaties zijn niet beschikbaar op dit apparaat'),
                    theme: "error"
                }));
            }
            return;
        }

        store.dispatch(setLoader({
            title: this.props.t('loaders.pleaseWait', 'Even geduld...'),
            message: this.props.t('loaders.requestingNotification', 'Je notificatie wordt aangevraagd'),
        }));
        let permissionResponse;
        try {
            permissionResponse = await Promise.race([askForPermissionToReceiveNotifications, this.watchdogTimeout].map(f => f()));
            console.log('[SilentCallButton] Permission response:', permissionResponse);
        } catch (error) {
            console.error('[SilentCallButton] Error getting permission:', error);
            permissionResponse = { status: "FAIL", error };
        }
        store.dispatch(clearLoader());

        if (permissionResponse.status === "SUCCESS") {
            localStorage.setItem('notifications', "granted");
            // Store both in new and legacy location for compatibility
            localStorage.setItem('fcm_token', permissionResponse.token);
            localStorage.setItem('token', permissionResponse.token);
            this.postForm(permissionResponse.token);
        } else {
            // Try to use existing token as fallback
            const existingToken = localStorage.getItem('fcm_token') || localStorage.getItem('token') || '';
            if (existingToken) {
                console.info('[SilentCallButton] Using existing token as fallback');
                localStorage.setItem('notifications', "granted");
                this.postForm(existingToken);
            } else {
                localStorage.setItem('notifications', "denied");
                const errorMsg = permissionResponse.error?.message || 'Unknown error';
                console.error('[SilentCallButton] Failed to get token:', errorMsg, permissionResponse.error);
                store.dispatch(setToast({
                    message: this.props.t('toasts.silentCallError', 'Er ging iets mis bij het aanvragen van je notificatie. Probeer het later opnieuw.'),
                    theme: "error"
                }));
            }
        }
    }

    postForm(token) {
        const { t } = this.props;
        store.dispatch(setLoader({
            title: t('loaders.pleaseWait', 'Even geduld...'),
            message: t('loaders.requestingNotification', 'Je notificatie wordt aangevraagd'),
        }));

        // Store token in both locations for compatibility
        localStorage.setItem('token', token);
        localStorage.setItem('fcm_token', token);
        localStorage.setItem('fcm_token_timestamp', Date.now().toString());

        const formData = new FormData();
        formData.append('gpslat', (localStorage.getItem('gpslat') || ''));
        formData.append('gpslong', (localStorage.getItem('gpslong') || ''));
        formData.append('latitude', (localStorage.getItem('latitude') || ''));
        formData.append('longitude', (localStorage.getItem('longitude') || ''));
        formData.append('straat', (localStorage.getItem('straat') || ''));
        formData.append('nr', (localStorage.getItem('nr') || ''));
        formData.append('gemeente', (localStorage.getItem('gemeente') || ''));
        formData.append('postcode', (localStorage.getItem('postcode') || ''));
        formData.append('land', (localStorage.getItem('land') || ''));
        formData.append('placeid', (localStorage.getItem('placeid') || ''));
        formData.append('adres', (localStorage.getItem('adres') || ''));
        formData.append('udid', (localStorage.getItem('udid') || ''));
        formData.append('token', token);
        formData.append('versioninfo', window.versionInfo || "");

        fetch(process.env.REACT_APP_API_HREF+"legacycopy.php?action=add_silent_oproep",{
            method: 'POST',
            body: formData,
        }).then(function(response) {
            store.dispatch(clearLoader());
            return response.json();
        }).then(data => {
            if (data.status === 201) {
                this.handleSubmitSucces();
            } else {
                this.handleSubmitFailure();
            }
        }).catch(error => {
            console.error('[SilentCallButton] Submit error:', error);
            this.handleSubmitFailure();
        });
    }

    handleSubmitFailure() {
        store.dispatch(setToast({
            message: this.props.t('toasts.silentCallError', 'Er ging iets mis bij het aanvragen van je notificatie. Probeer het later opnieuw.'),
            theme: "error"
        }));
    }

    handleSubmitSucces() {
        window.localStorage.setItem('silentCallActive', 1);
        this.setState({
            silentOproepGeplaatst: true,
        });

        store.dispatch(setToast({
            message: this.props.t('toasts.silentCallEnabled', 'We zullen je een notificatie sturen als er een ijskar in jouw buurt komt!'),
        }));
    }

    deleteForm(noConfirm = false) {
        const { t } = this.props;
        if (!noConfirm) {
            store.dispatch(setLoader({
                title: t('loaders.pleaseWait', 'Even geduld...'),
                message: t('loaders.removingNotification', 'We verwijderen je notificatieaanvraag'),
            }));
        }

        window.localStorage.getItem('token')

        const formData = new FormData();
        formData.append('udid', (window.localStorage.getItem('udid') || ''));
        formData.append('token', window.localStorage.getItem('token'));
        formData.append('versioninfo', window.versionInfo || "");

        fetch(process.env.REACT_APP_API_HREF+"legacycopy.php?action=remove_silent_oproep",{
            method: 'POST',
            body: formData,
        }).then(function(response) {
            store.dispatch(clearLoader());
            return response.json();
        }).then(data => {
            if (data.status === 200) {
                if (!noConfirm) this.handleDeleteSucces();
            } else {
                if (!noConfirm) this.handleDeleteFailure();
            }
        }).catch(error => {
            if (!noConfirm) this.handleDeleteFailure();
        });
    }

    handleDeleteFailure() {
        store.dispatch(setToast({
            message: this.props.t('toasts.silentCallDeleteError', 'Er ging iets mis bij het verwijderen van je notificatie. Probeer het later opnieuw.'),
            theme: "error"
        }));
    }

    handleDeleteSucces() {
        window.localStorage.setItem('silentCallActive', 0);
        this.setState({
            silentOproepGeplaatst: false,
        });

        store.dispatch(setToast({
            message: this.props.t('toasts.silentCallDisabled', 'Je notificatie is uitgezet. Je kan ze hier terug aanvragen.'),
        }));
    }

    render() {
        if (this.state.redirectToSilentAddress === true) {
            return <Navigate to='/silentaddress' />
        }

        const isActive = this.state.silentOproepGeplaatst;
        const { t } = this.props;

        return (
            <button
                type="button"
                className={`silentCallButton ${isActive ? 'active' : ''}`}
                onClick={(event) => {event.stopPropagation(); this.handleClick();}}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        event.stopPropagation();
                        this.handleClick();
                    }
                }}
                aria-label={isActive
                    ? t('buttons.disableNotifications', 'Notificaties uitschakelen')
                    : t('buttons.enableNotifications', 'Notificaties inschakelen voor ijskar in de buurt')}
                aria-pressed={isActive}
                title={t('buttons.notifyNearby', 'Waarschuw mij als er een ijskar in de buurt is!')}
                style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer'
                }}
            >
                <svg viewBox="0 0 60 60" width="60" height="60" className="radar-icon-svg" aria-hidden="true">
                    <defs>
                        <linearGradient id="radarBtnGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stopColor={isActive ? "#9e9e9e" : "#ffd700"}/>
                            <stop offset="100%" stopColor={isActive ? "#757575" : "#ffb800"}/>
                        </linearGradient>
                    </defs>
                    <circle cx="30" cy="30" r="27" fill="url(#radarBtnGradient)"/>
                    {/* Radar waves */}
                    <path d="M30 14 C40 14 48 22 48 32" stroke={isActive ? "#fff" : "#4a3728"} strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.8"/>
                    <path d="M30 21 C36 21 42 27 42 33" stroke={isActive ? "#fff" : "#4a3728"} strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.6"/>
                    {/* Center dot */}
                    <circle cx="30" cy="34" r="5" fill={isActive ? "#fff" : "#4a3728"}/>
                </svg>
            </button>
        )
    }
}

function mapStateToProps(state) {
    return {
        makeSilentCallOnOpen: state.tracker.makeSilentCallOnOpen ?? false,
    }
}

export default connect(mapStateToProps)(withTranslation(SilentCallButton));
